module.exports = __webpack_public_path__ + "static/media/Trykk-Starter-testen.684f3dbe.mp3";